"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingBlockStyled = void 0;

var _utils = require("../../utils");

var _styledComponents = require("styled-components");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var animate = /*#__PURE__*/(0, _styledComponents.keyframes)(["0%{background-position:-468px 0}100%{background-position:468px 0}"]);
var LoadingBlockStyled = (0, _utils.styled)('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  animation-duration: 1.25s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: ", ";\n  animation-timing-function: linear;\n  background: #f6f6f6;\n  background: linear-gradient(to right, #f6f6f6 8%, #f0f0f0 18%, #f6f6f6 33%);\n  background-size: 800px 104px;\n  position: relative;\n"])), function (_ref) {
  var width = _ref.width,
      fullWidth = _ref.fullWidth;
  return width && "".concat(width, "px") || fullWidth && "100%" || 'auto';
}, function (_ref2) {
  var height = _ref2.height;
  return height ? "".concat(height, "px") : 'auto';
}, animate);
exports.LoadingBlockStyled = LoadingBlockStyled;